<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5wtyo2/tc-custom/9781466859814.jpg?1737194764934" alt="This image is the cover for the book Diving for Starfish"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Diving for Starfish
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Both a history of fine jewelry coming out of Paris in the Golden Age and a tour through the secretive world of high-end, privately-sold jewelry, <i>Diving for Starfish</i> is a stylish detective story with a glittering piece of jewelry at its heart. </b><br/><br/>In the mid 1930s, in the workroom of the famous Parisian jeweler Boivin, a young jewelry designer named Juliette Moutard created one of the most coveted pieces of jewelry in the world—the famous starfish pin—still sought after today by aficionados of fine jewelry. <br/><br/>The starfish, created out of gold and encrusted with 71 cabochon rubies and 241 small amethysts, was distinctive because its five rays were articulated, meaning that they could curl and conform to the bustline or shoulder of the women who wore it. The House of Boivin made three of them. Two of the women who bought and wore the starfish were Claudette Colbert and Millicent Rogers. <br/><br/>Obsessed with the pin after she saw it in the private showroom of a Manhattan jewelry merchant, Cherie Burns set off on a journey to find out all she could about the elusive pins and the women who owned them. Her search took her around the world to Paris, London, New York, and Hollywood. <i>Diving for Starfish </i>is the story of these marvelous pieces of jewelry and the equally dazzling women who loved them.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cherie Burns
      </h2>
      
      <p class="authorDescription body article">CHERIE BURNS is the author of <I>Searching for Beauty,</I><I>The Great Hurricane: 1938, </I>and<I> Stepmotherhood. </I>Her work has appeared in <I>The Wall Street Journal</I>, <I>The New York Times Magazine, People,</I> and <I>Glamour,</I> among others. She lives in Taos, New Mexico.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c43062e8